import { render } from "./TableLoader.vue?vue&type=template&id=4b964888&scoped=true"
import script from "./TableLoader.vue?vue&type=script&lang=js"
export * from "./TableLoader.vue?vue&type=script&lang=js"

import "./TableLoader.vue?vue&type=style&index=0&id=4b964888&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b964888"]])

export default __exports__